import React, { useContext } from "react"
import {
  Main,
  Wrapper,
  Box1,
  Box2,
  Box3,
  ContentBox,
  TitleBox,
  TabletMain,
  TabletWrapper,
} from "./style"
import locationIcon from "../../../images/location2-icon.png"
import { ResolutionContext } from "../../../contexts/ResolutionContext"
import { renderRichText } from "gatsby-source-contentful/rich-text"

const Officecomponent = ({
  office_niepolomice,
  debosz_nieruchomosci,
  opening_hours,
  rynek,
}) => {
  const [isTablet] = useContext(ResolutionContext)
  if (isTablet) {
    return (
      <>
        <Main>
          <Wrapper>
            <TitleBox>
              <img src={locationIcon} alt="icon" />
              <h3>{office_niepolomice}</h3>
            </TitleBox>
            <Box1>{rynek && renderRichText(rynek)}</Box1>
          </Wrapper>
        </Main>
        <TabletMain>
          <TabletWrapper>
            <Box2>
              <pre>
                {debosz_nieruchomosci && renderRichText(debosz_nieruchomosci)}
              </pre>
            </Box2>

            <Box3>{opening_hours && renderRichText(opening_hours)}</Box3>
          </TabletWrapper>
        </TabletMain>
      </>
    )
  } else {
    return (
      <Main>
        <Wrapper>
          <TitleBox>
            <img src={locationIcon} alt="icon" />
            <h3>{office_niepolomice}</h3>
          </TitleBox>

          <ContentBox>
            <Box1>{rynek && renderRichText(rynek)}</Box1>
            <Box2>
              {debosz_nieruchomosci && renderRichText(debosz_nieruchomosci)}
            </Box2>

            <Box3>{opening_hours && renderRichText(opening_hours)}</Box3>
          </ContentBox>
        </Wrapper>
      </Main>
    )
  }
}

export default Officecomponent
